import { motion } from "framer-motion";

const petalAngles = [0, 45, 90, 135, 180, 225, 270, 315];

export const MarigoldMark = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 44 44" className={className} aria-hidden="true">
        <g fill="currentColor">
            {petalAngles.map((a) => (
                <ellipse
                    key={a}
                    cx="22"
                    cy="10.5"
                    rx="4.6"
                    ry="9"
                    transform={`rotate(${a} 22 22)`}
                    opacity={a % 90 === 0 ? 1 : 0.6}
                />
            ))}
        </g>
        <circle cx="22" cy="22" r="4.8" fill="#9A3412" />
    </svg>
);

export const PhillipMark = MarigoldMark;

export const BloomMark = ({ className = "h-9 w-9", delay = 0.1 }) => (
    <motion.svg
        viewBox="0 0 44 44"
        className={className}
        aria-hidden="true"
        initial="hidden"
        animate="visible"
    >
        <motion.g
            style={{ transformOrigin: "22px 22px" }}
            variants={{
                visible: {
                    transition: { staggerChildren: 0.05, delayChildren: delay },
                },
            }}
        >
            {petalAngles.map((a) => (
                <motion.ellipse
                    key={a}
                    cx="22"
                    cy="10.5"
                    rx="4.6"
                    ry="9"
                    fill="#D97706"
                    opacity={a % 90 === 0 ? 1 : 0.6}
                    transform={`rotate(${a} 22 22)`}
                    style={{ transformOrigin: "22px 22px" }}
                    variants={{
                        hidden: { scale: 0, opacity: 0 },
                        visible: {
                            scale: 1,
                            opacity: a % 90 === 0 ? 1 : 0.6,
                            transition: {
                                duration: 0.7,
                                ease: [0.22, 1, 0.36, 1],
                            },
                        },
                    }}
                />
            ))}
        </motion.g>
        <motion.circle
            cx="22"
            cy="22"
            r="4.8"
            fill="#9A3412"
            variants={{
                hidden: { scale: 0 },
                visible: {
                    scale: 1,
                    transition: { delay: delay + 0.55, duration: 0.5 },
                },
            }}
            style={{ transformOrigin: "22px 22px" }}
        />
    </motion.svg>
);
